import BigNumber from 'bignumber.js'

import twindexAbi from '../abi/twindex.json'
import { StakeFunc, StakeProps } from '../types'
import { safeGasEstimates } from '../utils'

const { abi } = twindexAbi

export const stakeTwindex: StakeFunc = async ({ web3, pool, walletAddress, amount, contractAddress }) => {
  try {
    const ct = new web3.eth.Contract(abi as any, contractAddress)
    const contractWithMethod = ct.methods.deposit(
      walletAddress,
      pool,
      new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed()
    )
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })
  } catch (e) {
    return false
  }
}

export const unStakeTwindex: StakeFunc = async ({ web3, pool, walletAddress, amount, contractAddress }) => {
  try {
    const ct = new web3.eth.Contract(abi as any, contractAddress)
    const contractWithMethod = ct.methods.withdraw(
      walletAddress,
      pool,
      new BigNumber(amount).times(new BigNumber(10).pow(18)).toFixed()
    )
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })

    return true
  } catch (e) {
    return false
  }
}

export const harvestTwindex: StakeFunc<Omit<StakeProps, 'amount'>> = async ({
  web3,
  pool,
  walletAddress,
  contractAddress
}) => {
  try {
    //TODO REFACTOR HERE
    const ct = new web3.eth.Contract(abi as any, contractAddress)
    const contractWithMethod = ct.methods.harvest(pool)
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({ from: walletAddress, gas: gasLimit })

    return true
  } catch (e) {
    return false
  }
}
